var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "cruise-info__ship",
          attrs: { to: _setup.props.ship.link, target: "_blank" },
        },
        [
          _c(_setup.vShip, { staticClass: "icon vicon-black" }),
          _vm._v(
            _vm._s(_setup.props.ship.name) +
              " [" +
              _vm._s(_setup.props.ship.company) +
              "] - " +
              _vm._s(_setup.props.ship.star)
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.ship.services.length
        ? _c(
            "div",
            {
              staticClass: "cruise-info__services",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _setup.serv_click.apply(null, arguments)
                },
              },
            },
            [_vm._v("Услуги на борту")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        _setup.Modal,
        {
          attrs: {
            title: "",
            "wrapper-class": "animate__animated",
            "modal-class": "fill-modal",
            "in-class": "animate__zoomIn hideScroll",
            "out-class": "animate__zoomOut hideScroll",
          },
          model: {
            value: _setup.isModalShown,
            callback: function ($$v) {
              _setup.isModalShown = $$v
            },
            expression: "isModalShown",
          },
        },
        [
          _c(
            "div",
            { staticClass: "fill-modal__header fill-modal-header" },
            [
              _c(
                _setup.ModalTitle,
                {
                  staticClass: "fill-modal-header__title",
                  on: {
                    close: function ($event) {
                      _setup.isModalShown = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_setup.props.ship.name) +
                      " [" +
                      _vm._s(_setup.props.ship.company) +
                      "] - " +
                      _vm._s(_setup.props.ship.star) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fill-modal__content shipServ" },
            _vm._l(_setup.props.ship.services, function ({ name, icon }) {
              return _c("div", { key: name, staticClass: "shipServ__item" }, [
                _c("img", {
                  staticClass: "shipServ__item__img",
                  attrs: { src: icon },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "shipServ__item__desc" }, [
                  _vm._v(_vm._s(name)),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }